/*
 * Lazy loader for background videos rendered by snippets/video-lazy.liquid.
 * Each video[data-lazy-video] carries data-src-small/-medium/-large mp4
 * rendition URLs and starts with no src (poster only). When the element
 * comes within 300px of the viewport we attach the rendition that fits the
 * effective screen width and start muted playback.
 */
(function () {
	function pickSrc(video) {
		var d = video.dataset;
		var w = Math.min(window.screen.width || Infinity, window.innerWidth) * Math.min(window.devicePixelRatio || 1, 2);
		if (w <= 900) return d.srcSmall || d.srcMedium || d.srcLarge;
		if (w <= 1500) return d.srcMedium || d.srcLarge || d.srcSmall;
		return d.srcLarge || d.srcMedium || d.srcSmall;
	}

	function load(video) {
		if (video.dataset.lazyLoaded) return;
		video.dataset.lazyLoaded = 'true';
		var src = pickSrc(video);
		if (!src) return;
		video.muted = true;
		video.src = src;
		video.load();
		var playing = video.play();
		if (playing && playing.catch) playing.catch(function () {});
	}

	function boot() {
		var videos = document.querySelectorAll('video[data-lazy-video]:not([data-lazy-loaded])');
		if (!videos.length) return;
		if (!('IntersectionObserver' in window)) {
			for (var i = 0; i < videos.length; i++) load(videos[i]);
			return;
		}
		var observer = new IntersectionObserver(
			function (entries) {
				for (var i = 0; i < entries.length; i++) {
					if (entries[i].isIntersecting) {
						observer.unobserve(entries[i].target);
						load(entries[i].target);
					}
				}
			},
			{ rootMargin: '300px 0px' }
		);
		for (var j = 0; j < videos.length; j++) observer.observe(videos[j]);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
	document.addEventListener('shopify:section:load', boot);
})();
